import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskedPhone'
})
export class MaskedPhonePipe implements PipeTransform {

  transform(val: string): string {

    if (val !== undefined && val !== null) {
      const arr = val.split(''); arr.splice(-7, 3, '***');
      return arr.join('');
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/pipes/maskedPhone.ts